import {
  CardLoading,
  CardNotice,
} from '@euler/app/flows/ai-suite/components/ChatCard';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { ChoiceRow } from './ChoiceRow';
import { useEditableDashboards } from './functions/useEditableDashboards';

/** 其他看板…: every dashboard the caller can edit, beyond the suggestions. */
export const OtherDashboards = memo(
  ({
    exclude,
    disabled,
    onChoose,
  }: {
    /** The suggestions already shown. */
    exclude: string[];
    disabled: boolean;
    onChoose: (dashboardId: string, name: string) => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const state = useEditableDashboards();
    if (state.kind === 'loading') return <CardLoading label="正在读取看板…" />;
    if (state.kind === 'failed')
      return (
        <CardNotice tone="danger" text="看板列表没有读取出来，请稍后重试。" />
      );
    const rest = state.dashboards.filter(item => !exclude.includes(item.id));
    if (!rest.length) return <CardNotice text="没有其他可以添加的看板了。" />;
    return (
      <View style={{ gap: rpx(8) }}>
        {rest.map(item => (
          <ChoiceRow
            key={item.id}
            name={item.name}
            disabled={disabled}
            onPress={() => onChoose(item.id, item.name)}
          />
        ))}
      </View>
    );
  },
);
